import {Order} from 'types';
import {ReactComponent as FlagIcon} from 'assets/icons/flag.svg';
import classNames from 'classnames';
import styles from './PriorityFlag.module.scss';

interface PriorityFlagProps {
  priority: Order['priority'];
}

export const getFlagStyle = (priority: Order['priority']) => {
  if (priority === 'high') {
    return styles.high;
  }
  if (priority === 'medium') {
    return styles.medium;
  }
  if (priority === 'low') {
    return styles.low;
  }
  return;
};

function PriorityFlag({priority}: PriorityFlagProps) {
  return (
    <FlagIcon className={classNames(styles.flag, getFlagStyle(priority))} />
  );
}
export default PriorityFlag;
